<div id="login" fxLayout="column">

    <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo-wrapper mb-32" fxLayout="column" fxLayoutAlign="center center">
                <div fxLayout="column" fxLayoutAlign="center start">
                    <img class="logo" src="assets/images/logos/artstuff.svg">
                    <img src="assets/images/logos/portal.svg" fxLayout fxHide.gt-xs>
                </div>
            </div>

            <mat-error class="mb-16" *ngIf="errLogin" class="login-error" fxLayout="row" fxLayoutAlign="center center">
                <mat-icon matSuffix>warning</mat-icon>
                <mat-label>{{'LOGIN.OTHER.LOGIN_ERROR' | translate }}</mat-label>
            </mat-error>

            <form class="mt-24" name="loginForm" [formGroup]="loginForm" novalidate>

                <mat-form-field appearance="outline">
                    <mat-label>{{'LOGIN.USERNAME' | translate }}</mat-label>
                    <input matInput formControlName="username">
                    <mat-icon matSuffix class="secondary-text">email</mat-icon>
                    <mat-error *ngIf="loginForm.get('username').hasError('required')">
                        {{'LOGIN.VALIDATION.USERNAME' | translate }}
                    </mat-error>
                    <mat-error *ngIf="!loginForm.get('username').hasError('required') &&
                                loginForm.get('username').hasError('email')">
                        {{'LOGIN.VALIDATION.USERNAME_INVALID' | translate }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'LOGIN.PASSWORD' | translate }}</mat-label>
                    <input matInput type="password" formControlName="password">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error>
                        {{'LOGIN.VALIDATION.PASSWORD' | translate }}
                    </mat-error>
                </mat-form-field>

                <div class="remember-forgot-password" fxLayout="row" fxLayoutAlign="space-between center">
                    <mat-checkbox class="remember-me" aria-label="Remember Me">
                        {{'LOGIN.ACTION.REMEMBER_ME' | translate }}
                    </mat-checkbox>

                    <!-- <a class="forgot-password" [routerLink]="'/pages/auth/forgot-password'"> -->
                    <a class="artstuff-hyperlink text-semibold"  (click)="openDialog()">
                        {{'LOGIN.ACTION.FORGOT_PASSWORD' | translate }}
                    </a>
                </div>

                <button mat-raised-button color="accent" class="submit-button" aria-label="LOG IN"
                        [disabled]="loginForm.invalid" (click)="onLoginClick()">
                    {{'LOGIN.ACTION.LOGIN_PASSWORD' | translate }}
                </button>

            </form>

            <div class="separator" *ngIf="enableGoogleLogin">
                <span class="text">{{'LOGIN.OTHER.SEPERATOR' | translate }}</span>
            </div>

            <button mat-raised-button class="google" *ngIf="enableGoogleLogin">
                {{'LOGIN.ACTION.LOGIN_GOOGLE' | translate }}
            </button>

<!--            <button mat-raised-button class="facebook">-->
<!--                Log in with Facebook-->
<!--            </button>-->

<!--            <div class="register" fxLayout="column" fxLayoutAlign="center center">-->
<!--                <span class="text">Don't have an account?</span>-->
<!--                <a class="link" [routerLink]="'/pages/auth/register'">Create an account</a>-->
<!--            </div>-->

        </div>

    </div>

</div>
